import { Pipe, PipeTransform } from '@angular/core';
import {
	ExploitationType,
	FeatureDisplayAlertes,
	FeatureDisplayTaches,
	FeatureSaisieIpe,
	FeatureSaisiePesee,
	FeatureSaisieReproduction,
	FeatureSaisieSanitaire,
	FeatureUpdateLots,
	Filiere,
	FlagIPE,
	FlagMouvement,
	FlagVAE,
	IdentifiantPrimaire,
	NiveauAcces,
	OffreAbonnement,
	PoidsAgeTypeAgeReference,
	UserRole,
} from './dtos';
import { TranslateKey } from './translate.service';

@Pipe({
	name: 'enumToKey',
})
export class EnumToKeyPipe implements PipeTransform {
	private userRole = {
		[UserRole.ADMINISTRATEUR]: 'userrole.administrateur',
		[UserRole.ELEVEUR]: 'userrole.eleveur',
	};
	private filiere = {
		[Filiere.BIOLOGIQUE]: 'filiere.biologique',
		[Filiere.CONVENTIONNELLE]: 'filiere.conventionnelle',
	};
	private niveauAcces = {
		[NiveauAcces.CONSULTATION]: 'niveauacces.consultation',
		[NiveauAcces.SAISIE]: 'niveauacces.saisie',
	};
	private ExploitationType = {
		[ExploitationType.FAKE]: 'exploitationtype.fake',
		[ExploitationType.LIVE]: 'exploitationtype.live',
	};
	private IdentifiantPrimaire = {
		[IdentifiantPrimaire.NOM]: 'identifiantprimaire.nom',
		[IdentifiantPrimaire.NUMERO_NATIONAL]: 'identifiantprimaire.numeronational',
		[IdentifiantPrimaire.NUMERO_TRAVAIL]: 'identifiantprimaire.numerotravail',
	};
	private OffreAbonnement = {
		[OffreAbonnement.PERFORMANCE]: 'offreabonnement.performance',
		[OffreAbonnement.ESSENTIEL]: 'offreabonnement.essentiel',
	};
	private FlagIPE = {
		[FlagIPE.IPE_DISABLED]: 'flagipe.disabled',
		[FlagIPE.IPE_ENABLED]: 'flagipe.enabled',
	};
	private FlagMouvement = {
		[FlagMouvement.MOUVEMENT_DISABLED]: 'flagmouvement.disabled',
		[FlagMouvement.MOUVEMENT_ENABLED]: 'flagmouvement.enabled',
	};
	private FlagVAE = {
		[FlagVAE.VAE_DISABLED]: 'flagvae.disabled',
		[FlagVAE.VAE_ENABLED]: 'flagvae.enabled',
	};
	private FeatureDisplayAlertes = {
		[FeatureDisplayAlertes.DISABLED]: 'featuredisplayalertes.disabled',
		[FeatureDisplayAlertes.ENABLED]: 'featuredisplayalertes.enabled',
	};
	private FeatureDisplayTaches = {
		[FeatureDisplayTaches.DISABLED]: 'featuredisplaytaches.disabled',
		[FeatureDisplayTaches.ENABLED]: 'featuredisplaytaches.enabled',
	};
	private FeatureSaisieIpe = {
		[FeatureSaisieIpe.DISABLED]: 'featuresaisieipe.disabled',
		[FeatureSaisieIpe.ENABLED]: 'featuresaisieipe.enabled',
	};
	private FeatureSaisiePesee = {
		[FeatureSaisiePesee.DISABLED]: 'featuresaisiepesee.disabled',
		[FeatureSaisiePesee.ENABLED]: 'featuresaisiepesee.enabled',
	};
	private FeatureSaisieReproduction = {
		[FeatureSaisieReproduction.DISABLED]: 'featuresaisiereproduction.disabled',
		[FeatureSaisieReproduction.ENABLED]: 'featuresaisiereproduction.enabled',
	};
	private FeatureSaisieSanitaire = {
		[FeatureSaisieSanitaire.DISABLED]: 'featuresaisiesanitaire.disabled',
		[FeatureSaisieSanitaire.ENABLED]: 'featuresaisiesanitaire.enabled',
	};
	private FeatureUpdateLots = {
		[FeatureUpdateLots.DISABLED]: 'featureupdatelots.disabled',
		[FeatureUpdateLots.ENABLED]: 'featureupdatelots.enabled',
	};
	private PoidsAgeTypeAgeReference = {
		[PoidsAgeTypeAgeReference.JOURS_120]: 'poidsagetypeagereference.jours120',
		[PoidsAgeTypeAgeReference.JOURS_210]: 'poidsagetypeagereference.jours210',
		[PoidsAgeTypeAgeReference.JOURS_360]: 'poidsagetypeagereference.jours360',
		[PoidsAgeTypeAgeReference.JOURS_540]: 'poidsagetypeagereference.jours540',
		[PoidsAgeTypeAgeReference.JOURS_720]: 'poidsagetypeagereference.jours720',
	};
	private etat = { ENABLED: 'etat.active', DISABLED: 'etat.desactive' };

	transform(value: string): TranslateKey {
		const keys = {
			...this.etat,
			...this.filiere,
			...this.niveauAcces,
			...this.FeatureDisplayAlertes,
			...this.FeatureDisplayTaches,
			...this.FeatureSaisieIpe,
			...this.FeatureSaisiePesee,
			...this.FeatureSaisieReproduction,
			...this.FeatureSaisieSanitaire,
			...this.FeatureUpdateLots,
			...this.FlagIPE,
			...this.FlagMouvement,
			...this.FlagVAE,
			...this.OffreAbonnement,
			...this.PoidsAgeTypeAgeReference,
			...this.ExploitationType,
			...this.IdentifiantPrimaire,
			...this.userRole,
		};
		if (value in keys) {
			return keys[value];
		} else {
			console.error(`Missing translation key for ${value}`);
			throw 'Missing KEY';
		}
	}
}
